import { useState, useEffect, useRef, type ReactNode } from 'react'
import './FileBrowser.css'

interface InlineTreeInputProps {
    depth: number
    defaultValue?: string
    icon?: ReactNode
    onConfirm: (val: string) => void
    onCancel: () => void
}

export default function InlineTreeInput({ depth, defaultValue = '', icon, onConfirm, onCancel }: InlineTreeInputProps) {
    const [value, setValue] = useState(defaultValue)
    const inputRef = useRef<HTMLInputElement>(null)

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus()
            // Select filename without extension if possible
            const extIndex = defaultValue.lastIndexOf('.')
            if (extIndex > 0) {
                inputRef.current.setSelectionRange(0, extIndex)
            } else {
                inputRef.current.select()
            }
        }
    }, [defaultValue])

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            e.preventDefault()
            e.stopPropagation()
            onConfirm(value)
        } else if (e.key === 'Escape') {
            e.preventDefault()
            e.stopPropagation()
            onCancel()
        }
    }

    return (
        <div className="tree-item tree-inline-input" style={{ paddingLeft: `${depth * 20 + 8}px` }}>
            {icon && <span className="tree-icon-wrapper">{icon}</span>}
            <input
                ref={inputRef}
                type="text"
                value={value}
                onChange={e => setValue(e.target.value)}
                onKeyDown={handleKeyDown}
                onBlur={() => onConfirm(value)}
                className="inline-input-field"
                onClick={e => e.stopPropagation()}
                autoCapitalize="off"
                autoComplete="off"
                autoCorrect="off"
                spellCheck={false}
            />
        </div>
    )
}
